import React, { useEffect, useMemo, useState } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';
import { BaSeAccountProfile, BaSeAvatar, BaSeLogoSebrae } from '@base/react';
import { hasAdminRole, hasGestorSSERole } from '../../../../utils/hasPermission';
import AuthContext from '../../../../auth';
import { pages } from '../../../routes/pages';
import { useApp } from '../../../../context/app';
import { inPersistentStore } from "../../../../utils/storage.util";

const Sidebar = ({ collapsed, setCollapsed }) => {
  const [allowedPages, setAllowedPages] = useState([]);
  const urlSelected = window?.location?.pathname;

  const { setNewLayout } = useApp();

  useEffect(() => {
    const fetchAllowedItems = async () => {
      const items = [];
      const isAdminRole = await hasAdminRole();
      const isGestorSSERole = await hasGestorSSERole();
      for (const pg of pages) {
        if (!pg?.notAuth) {
          const allowed = isAdminRole || !!pg?.isPublicAccess || (pg?.allowAccessGestorSSE && isGestorSSERole);
          if (allowed) {
            items.push(pg);
          }
        }
      }
      setAllowedPages(items);
    };
    fetchAllowedItems();
  }, []);

  const pagesWithoutAuth = useMemo(() => pages.filter((p) => p?.notAuth), []);

  const SidebarItem = ({ page }) => {
    const isSelected = urlSelected.includes(page?.url);
    return (
        <div
            className={`sidebar-link-item ${
                isSelected ? 'selected' : ''
            } ${collapsed && 'collapsed'} `}
        >
          <Link to={page?.url ?? null} onClick={page?.action}>
            {page.icon(isSelected)}
            {!collapsed && (
                <p
                    className={
                      isSelected ? 'link-text selected' : 'link-text'
                    }
                >
                  {' '}
                  {page.description}
                </p>
            )}
          </Link>
          {isSelected  && (
              <div
                  className={`${
                      collapsed ? 'selected-indicator-collapsed ' : 'selected-indicator'
                  }`}
              ></div>
          )}
        </div>
    );
  }
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleToOldLayout = () => {
    setNewLayout(false);
    inPersistentStore.setItem('newLayout', false);
  }

  return (
    <AuthContext.Consumer>
      {({ authenticated, keycloak, user }) => {
        return (
          <div className={`layout-sidebar ${collapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-content">
              <div className="sidebar-header">
                <div className="logo">
                  <BaSeLogoSebrae width={collapsed ? '73' : '85'} />
                </div>
                <div className="sidebar-toggle" onClick={toggleSidebar}>
                  <i
                    className={
                      !collapsed
                        ? 'ri-arrow-left-s-line'
                        : 'ri-arrow-right-s-line'
                    }
                  ></i>
                </div>
                <div className="user-info-content">
                  {authenticated ? (
                    <>
                      <div className="picture" title={user?.name}>
                        <BaSeAvatar keycloak={keycloak} />
                      </div>
                      {!collapsed && <p className="name">{user?.name}</p>}
                    </>
                  ) : (
                    <BaSeAccountProfile keycloak={keycloak} />
                  )}
                </div>
              </div>
              <div className="sidebar-links-container">
                {authenticated
                  ? allowedPages?.map((pg, idx) => (
                      <SidebarItem page={pg} key={idx.toString()} />
                    ))
                  : pagesWithoutAuth?.map((pg, idx) => (
                      <SidebarItem page={pg} key={idx.toString()} />
                    ))}
              </div>
              <div className="sidebar-bottom">
                <SidebarItem
                  page={{
                    url: '/configuracoes',
                    action: () => handleToOldLayout(),
                    description: 'Configurações',
                    icon: (isSelected) => (
                      <i
                        className="ri-settings-2-line"
                        style={{
                          color: isSelected
                            ? '#0061c6'
                            : 'rgba(57, 164, 223, 1)',
                          fontSize: '24px',
                        }}
                      ></i>
                    ),
                  }}
                />

                <SidebarItem
                  page={{
                    url: '/sair',
                    action: keycloak.logout,
                    description: 'Sair',
                    icon: (isSelected) => (
                      <i
                        className="ri-logout-box-line"
                        style={{
                          color: isSelected
                            ? '#0061c6'
                            : 'rgba(57, 164, 223, 1)',
                          fontSize: '24px',
                        }}
                      ></i>
                    ),
                  }}
                />
              </div>
              <div style={{margin: '0 auto', cursor: "pointer", marginTop: '-30px'}}>
                <a href="#/" onClick={() => handleToOldLayout()} style={{color: '#0061c6'}}>Alternar layout</a>
              </div>
            </div>
          </div>
        );
      }}
    </AuthContext.Consumer>
  );
};

export default Sidebar;
